import React from 'react'
import { useHistory } from 'react-router-dom'
import Style from './MenuSelection.module.css'
const MenuSelection = ({Imgsrc,title,linkholder}) => {
    const history=useHistory()

    const pageRoutingHandler=()=>{
        
        setTimeout(()=>history.push(linkholder),500)
    }
 
    return (
        <div className={Style.MenuSelectionHolder} onClick={pageRoutingHandler}>
            <div className={Style.ImageHolder}><img src={Imgsrc} alt='navigation' /></div>
            <p style={{fontSize:".8rem"}}>{title}</p>
        </div>
    )
}

export default MenuSelection
